<template>
  <div class="page">
    <div class="ctrl">
      <a-button type="primary" @click="show_create = true">添加字段</a-button>
    </div>
    <a-table
      class="sec"
      size="small"
      :rowKey="(record) => record.id"
      bordered
      :columns="columns"
      :data-source="list"
      :pagination="false"
    >
      <template slot="options" slot-scope="text, record">
        <div v-for="(item, index) in record.options" :key="index">
          {{item.val}}
          <span style="margin-left: 10px" v-if="item.limit">（人数：{{item.limit}}）</span>
          <span style="margin-left: 10px" v-if="item.fee">（费用：{{item.fee}}）</span>
        </div>
      </template>

      <template slot="action" slot-scope="text, record">
        <a href="javascript:;" @click="update(record)">编辑</a>
        <a-divider type="vertical" />

        <a-popconfirm
          title="确定要删除吗"
          ok-text="删除"
          cancel-text="取消"
          @confirm="updateStatus(record.id, 0)"
        >
          <a href="javascript:;">删除</a>
        </a-popconfirm>
      </template>
    </a-table>

    <CreateModal v-if="show_create" :activity_id="activity_id" @callback="created" />
    <UpdateModal v-if="show_update" :oldData="selectedData" @callback="updated" />
  </div>
</template>

<style lang='scss' scoped>
</style>

<script>
import CreateModal from "./create";
import UpdateModal from "./update";

const columns = [
  {
    title: "排序",
    dataIndex: "order",
  },
  {
    title: "字段",
    dataIndex: "title",
  },
  {
    title: "类型",
    dataIndex: "type",
  },
  {
    title: "选项",
    scopedSlots: {
      customRender: "options",
    },
  },
  {
    title: "默认值",
    dataIndex: "default_val",
  },
  {
    title: "上传限量",
    dataIndex: "upload_limit",
  },
  {
    title: "提示语",
    dataIndex: "tips",
  },
  {
    title: "操作",
    scopedSlots: {
      customRender: "action",
    },
  },
];

export default {
  components: { CreateModal, UpdateModal },
  data() {
    return {
      columns,
      activity_id: null,
      list: [],
      show_create: false,
      show_update: false,
      selectedData: {}
    };
  },
  created() {
    this.activity_id = this.$route.query.activity_id;
    this.getList();
  },
  methods: {
    changePage(e) {
      this.page.now_page = e;
      this.getList();
    },

    async getList() {
      if (!this.activity_id) return;
      const r = await this.$axios.get("/activity/form/getList", {
        params: {
          activity_id: this.activity_id,
        },
      });

      if (r.status != 1) return;
      this.list = r.list;
    },

    async updateStatus(id, status) {
      const r = await this.$axios.post("/activity/form/updateStatus", {
        id,
        status,
      });

      if (r.status == 1) this.getList();
    },

    created(e) {
      this.show_create = false;
      if (e) this.getList();
    },

    update (data) {
      this.show_update = true;
      this.selectedData = data
    },

    updated(e) {
      this.show_update = false;
      if (e) this.getList();
    },
  },
};
</script>